<template>
  <svg
    :x="svgCoords.x"
    :y="svgCoords.y"
    width="250"
    height="475"
    id="milestone-statue-dev"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 194.8 396.8"
    aria-labelledby="jamstacknystatue"
  >
    <title id="jamstacknystatue">Jamstack New York</title>
    <g id="StatueofLiberty">
      <g id="Building">
        <path
          id="Vector"
          class="cls-1"
          d="M130.2,351.3l65.5-37.9-65.5-37.8L64.7,313.4Z"
          transform="translate(-0.9 -0.2)"
        />
        <g id="Group">
          <g id="Group_2" data-name="Group 2">
            <path
              id="Vector_2"
              data-name="Vector 2"
              class="cls-2"
              d="M186,314.2l-55.6,32.1V309.4L186,277.3Z"
              transform="translate(-0.9 -0.2)"
            />
            <path
              id="Vector_3"
              data-name="Vector 3"
              class="cls-3"
              d="M74.8,314.2l55.6,32.1V309.4L74.8,277.3Z"
              transform="translate(-0.9 -0.2)"
            />
          </g>
          <g id="Group_3" data-name="Group 3">
            <path
              id="Vector_4"
              data-name="Vector 4"
              class="cls-3"
              d="M130.4,314l63.2-36.5-63.2-36.6L67.2,277.5Z"
              transform="translate(-0.9 -0.2)"
            />
            <path
              id="Vector_5"
              data-name="Vector 5"
              class="cls-3"
              d="M193.6,282l-63.2,36.5V314l63.2-36.5Z"
              transform="translate(-0.9 -0.2)"
            />
            <path
              id="Vector_6"
              data-name="Vector 6"
              class="cls-3"
              d="M67.2,282l63.2,36.5V314L67.2,277.5Z"
              transform="translate(-0.9 -0.2)"
            />
          </g>
          <g id="Group_4" data-name="Group 4">
            <path
              id="Vector_7"
              data-name="Vector 7"
              class="cls-3"
              d="M130.4,288.7,186,256.6l-55.6-32.1L74.8,256.6Z"
              transform="translate(-0.9 -0.2)"
            />
            <path
              id="Vector_8"
              data-name="Vector 8"
              class="cls-2"
              d="M186,277.4l-55.6,32.1V288.7L186,256.6Z"
              transform="translate(-0.9 -0.2)"
            />
            <path
              id="Vector_9"
              data-name="Vector 9"
              class="cls-3"
              d="M74.8,277.4l55.6,32.1V288.7L74.8,256.6Z"
              transform="translate(-0.9 -0.2)"
            />
          </g>
          <g id="Group_5" data-name="Group 5">
            <path
              id="Vector_10"
              data-name="Vector 10"
              class="cls-2"
              d="M177.8,256.1l-47.4,27.4V246.4L177.8,219v37.1Z"
              transform="translate(-0.9 -0.2)"
            />
            <path
              id="Vector_11"
              data-name="Vector 11"
              class="cls-3"
              d="M83,256.1l47.4,27.4V246.4L83,219.1Z"
              transform="translate(-0.9 -0.2)"
            />
          </g>
          <g id="Group_6" data-name="Group 6">
            <path
              id="Vector_12"
              data-name="Vector 12"
              class="cls-3"
              d="M130.4,246.1,186,214l-55.6-32.1L74.8,214Z"
              transform="translate(-0.9 -0.2)"
            />
            <path
              id="Vector_13"
              data-name="Vector 13"
              class="cls-3"
              d="M186,218l-55.6,32.1v-4L186,214Z"
              transform="translate(-0.9 -0.2)"
            />
            <path
              id="Vector_14"
              data-name="Vector 14"
              class="cls-3"
              d="M74.8,218l55.6,32.1v-4L74.8,214Z"
              transform="translate(-0.9 -0.2)"
            />
          </g>
          <g id="Group_7" data-name="Group 7">
            <path
              id="Vector_15"
              data-name="Vector 15"
              class="cls-3"
              d="M168.1,254.6V257l5.4-3.1V229l-2,1.2v22.5Z"
              transform="translate(-0.9 -0.2)"
            />
            <path
              id="Vector_16"
              data-name="Vector 16"
              class="cls-3"
              d="M168.1,232.1v22.5l3.3-1.9V230.2Z"
              transform="translate(-0.9 -0.2)"
            />
          </g>
          <g id="Group_8" data-name="Group 8">
            <path
              id="Vector_17"
              data-name="Vector 17"
              class="cls-3"
              d="M157.1,261v2.4l5.4-3.1V235.4l-2,1.2V259Z"
              transform="translate(-0.9 -0.2)"
            />
            <path
              id="Vector_18"
              data-name="Vector 18"
              class="cls-3"
              d="M157.1,238.4V261l3.3-1.9V236.6Z"
              transform="translate(-0.9 -0.2)"
            />
          </g>
          <g id="Group_9" data-name="Group 9">
            <path
              id="Vector_19"
              data-name="Vector 19"
              class="cls-3"
              d="M146.1,267.3v2.4l5.4-3.1V241.7l-2,1.2v22.5Z"
              transform="translate(-0.9 -0.2)"
            />
            <path
              id="Vector_20"
              data-name="Vector 20"
              class="cls-3"
              d="M146.1,244.8v22.5l3.3-1.9V242.9Z"
              transform="translate(-0.9 -0.2)"
            />
          </g>
          <g id="Group_10" data-name="Group 10">
            <path
              id="Vector_21"
              data-name="Vector 21"
              class="cls-3"
              d="M135.1,273.7v2.4l5.4-3.1V248.1l-2,1.2v22.5Z"
              transform="translate(-0.9 -0.2)"
            />
            <path
              id="Vector_22"
              data-name="Vector 22"
              class="cls-3"
              d="M135.1,251.1v22.5l3.3-1.9V249.2Z"
              transform="translate(-0.9 -0.2)"
            />
          </g>
          <g id="Group_11" data-name="Group 11">
            <path
              id="Vector_23"
              data-name="Vector 23"
              class="cls-3"
              d="M92.6,254.6V257l-5.4-3.1V229l2,1.2v22.5Z"
              transform="translate(-0.9 -0.2)"
            />
            <path
              id="Vector_24"
              data-name="Vector 24"
              class="cls-2"
              d="M92.6,232.1v22.5l-3.3-1.9V230.2Z"
              transform="translate(-0.9 -0.2)"
            />
          </g>
          <g id="Group_12" data-name="Group 12">
            <path
              id="Vector_25"
              data-name="Vector 25"
              class="cls-3"
              d="M103.6,261v2.4l-5.4-3.1V235.4l2,1.2V259Z"
              transform="translate(-0.9 -0.2)"
            />
            <path
              id="Vector_26"
              data-name="Vector 26"
              class="cls-2"
              d="M103.6,238.4V261l-3.3-1.9V236.6Z"
              transform="translate(-0.9 -0.2)"
            />
          </g>
          <g id="Group_13" data-name="Group 13">
            <path
              id="Vector_27"
              data-name="Vector 27"
              class="cls-3"
              d="M114.6,267.3v2.4l-5.4-3.1V241.7l2,1.2v22.5Z"
              transform="translate(-0.9 -0.2)"
            />
            <path
              id="Vector_28"
              data-name="Vector 28"
              class="cls-2"
              d="M114.6,244.8v22.5l-3.3-1.9V242.9Z"
              transform="translate(-0.9 -0.2)"
            />
          </g>
          <g id="Group_14" data-name="Group 14">
            <path
              id="Vector_29"
              data-name="Vector 29"
              class="cls-3"
              d="M125.6,273.7v2.4l-5.4-3.1V248.1l2,1.2v22.5Z"
              transform="translate(-0.9 -0.2)"
            />
            <path
              id="Vector_30"
              data-name="Vector 30"
              class="cls-2"
              d="M125.6,251.1v22.5l-3.3-1.9V249.2Z"
              transform="translate(-0.9 -0.2)"
            />
          </g>
        </g>
      </g>
      <g id="Circle">
        <path
          id="Vector_31"
          data-name="Vector 31"
          class="cls-3"
          d="M96.7,209h1.8a22.3,22.3,0,0,1,8-7.4c13.1-7.6,34.2-7.6,47.3,0a21.4,21.4,0,0,1,8,7.4h1.8v6.3c0,4.9-3.3,9.9-9.8,13.7-13.1,7.6-34.2,7.6-47.3,0-6.5-3.8-9.8-8.7-9.8-13.7Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_32"
          data-name="Vector 32"
          class="cls-2"
          d="M106.5,223.2c13.1,7.6,34.2,7.6,47.3,0s13.1-19.8,0-27.4-34.2-7.6-47.3,0S93.4,215.7,106.5,223.2Z"
          transform="translate(-0.9 -0.2)"
        />
      </g>
      <g id="Statue">
        <path
          id="Vector_33"
          data-name="Vector 33"
          class="cls-4"
          d="M103.5,200.2c.3-2.5,3.3-2.6,6.7-2.4,13.7.5,21.7,4.3,21.7,4.3s33.3,8,25.1,17c-.9.9-2.8,2.2-4.2,2.1s-2.4,2.5-2.6,2.7-2.5,1.2-4.1.7c-.1.5-2.1,1.3-2.2,1.4-2.1,1.6-3.4.1-4.4-.7a2.6,2.6,0,0,1-3.9-.2,2.2,2.2,0,0,1-.3-.9,4.6,4.6,0,0,1-4.6-.8,2.4,2.4,0,0,1-.4-1.3,2.6,2.6,0,0,1-3.3-.5,2.4,2.4,0,0,1-.4-1.3,3.5,3.5,0,0,1-4-.4,5.8,5.8,0,0,1-.3-2.5h-.1a2.7,2.7,0,0,1-3.2-.6,1.9,1.9,0,0,1-.4-1.1,3.8,3.8,0,0,1-4.3-.2,4,4,0,0,1-.3-2.1,8.2,8.2,0,0,1-5.8-2.2,5.5,5.5,0,0,1-.6-2.7c-.8-.1-3.1-.2-3.7-.8s-.3-2.2-.4-4A9.7,9.7,0,0,1,103.5,200.2Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_34"
          data-name="Vector 34"
          class="cls-4"
          d="M142.3,69.1l2.6,19.1-3,6.4L135,90.1l-.5-14.3Z"
          transform="translate(-0.9 -0.2)"
        />
        <g id="Group_15" data-name="Group 15">
          <path
            id="Vector_35"
            data-name="Vector 35"
            class="cls-4"
            d="M106,98.2l2.8-.6-8.1,35.7-2.8.7-8.8-29.3Z"
            transform="translate(-0.9 -0.2)"
          />
          <path
            id="Vector_36"
            data-name="Vector 36"
            class="cls-2"
            d="M108.8,97.6l8.3,27.4-16.4,8.3L92,104.1Z"
            transform="translate(-0.9 -0.2)"
          />
          <path
            id="Vector_37"
            data-name="Vector 37"
            class="cls-4"
            d="M108.8,97.6l8.3,27.4-6.8,3.5s2.6-10.1,1.3-12.1-1.5-.6-.7-6.4c-1-1-.5-4.9-1-6.9S108.8,97.6,108.8,97.6Z"
            transform="translate(-0.9 -0.2)"
          />
        </g>
        <path
          id="Vector_38"
          data-name="Vector 38"
          class="cls-4"
          d="M97.5,115.4c-1.4-1-5.8-.8-5.9.6s2,6,3,6.4,3.5-.4,3.3-2.1S98.8,116.4,97.5,115.4Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_39"
          data-name="Vector 39"
          class="cls-3"
          d="M96.8,115.6c-1.3-1-5.8-.8-5.9.6s2,6,3,6.4,3.5-.5,3.4-2.1S98.1,116.7,96.8,115.6Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_40"
          data-name="Vector 40"
          class="cls-4"
          d="M104.6,198.9c.3-2.5.5-5.2.7-8.2s.3-5.3.5-8q.5-6.4,1.2-14.1v-.2c.5-5.3,1.4-11,2.5-17.1,3.5-1.7,40.1,29.6,40.1,29.6s2.4,11.6,3.6,21.9c1.2,7.3,2.1,15.1,1.2,16.1a4,4,0,0,1-3.5,1,4.5,4.5,0,0,1-.5,2.3c-1.3,1.4-3.7,1.2-5.4.8a4.1,4.1,0,0,1-.2,1,3.8,3.8,0,0,1-5-.3,2.6,2.6,0,0,1-3.9-.2,3,3,0,0,1-.3-.9,4.6,4.6,0,0,1-4.6-.8,2.4,2.4,0,0,1-.4-1.3,2.6,2.6,0,0,1-3.3-.5,2.8,2.8,0,0,1-.4-1.3,3.7,3.7,0,0,1-4-.4,5.8,5.8,0,0,1-.3-2.5.1.1,0,0,1-.1-.1,2.6,2.6,0,0,1-3.2-.7,1.9,1.9,0,0,1-.4-1.1,3.6,3.6,0,0,1-4.3-.2,4.3,4.3,0,0,1-.3-2.1,8.7,8.7,0,0,1-5.8-2.2,5.5,5.5,0,0,1-.6-2.7,3.7,3.7,0,0,1-2.2-1c-.3-.3-.4-1.6-.5-3.4A5.1,5.1,0,0,1,104.6,198.9Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_41"
          data-name="Vector 41"
          class="cls-4"
          d="M111.3,162.4c-4.4,30.4-3.6,44.3-3.6,44.3S107.9,190.4,111.3,162.4Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_42"
          data-name="Vector 42"
          class="cls-4"
          d="M109,168.3c-3.6,32.7-3.9,33.7-3.9,33.7S104.8,197.2,109,168.3Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_43"
          data-name="Vector 43"
          class="cls-4"
          d="M129.9,181.9c.1,29.8-3.3,36.7-3.3,36.7S128.9,206.1,129.9,181.9Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_44"
          data-name="Vector 44"
          class="cls-4"
          d="M138.5,186.4c.1,29.8-3.3,36.7-3.3,36.7S137.5,210.6,138.5,186.4Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_45"
          data-name="Vector 45"
          class="cls-4"
          d="M114.8,167.3c-2.1,23.3-2.4,23.9-2.4,23.9S112,187.6,114.8,167.3Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_46"
          data-name="Vector 46"
          class="cls-4"
          d="M145.6,183.7c-2.1,23.3-.6,39.4-.6,39.4A177.3,177.3,0,0,1,145.6,183.7Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_47"
          data-name="Vector 47"
          class="cls-4"
          d="M125.3,172.4c-2.1,23.3-2.4,23.9-2.4,23.9S122.4,192.7,125.3,172.4Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_48"
          data-name="Vector 48"
          class="cls-4"
          d="M112.5,165.4c-2.1,32-2.4,32.9-2.4,32.9S109.3,193.2,112.5,165.4Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_49"
          data-name="Vector 49"
          class="cls-4"
          d="M129.2,178.4c-2.1,23.3-3.9,25.3-3.9,25.3S126.3,198.6,129.2,178.4Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_50"
          data-name="Vector 50"
          class="cls-4"
          d="M121.9,171.7c-3,15.9-4.2,17.4-4.2,17.4S118.6,185.6,121.9,171.7Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_51"
          data-name="Vector 51"
          class="cls-4"
          d="M116.8,171.7c-2.2,22.4-3.7,24.6-3.7,24.6S114,191.3,116.8,171.7Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_52"
          data-name="Vector 52"
          class="cls-4"
          d="M144.3,175.6c7.5,22.2,6.7,24.7,6.7,24.7S149.9,195.3,144.3,175.6Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_53"
          data-name="Vector 53"
          class="cls-4"
          d="M136.7,185.2c-.4,23.4-2.7,31.3-2.7,31.3S135.3,205.6,136.7,185.2Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_54"
          data-name="Vector 54"
          class="cls-4"
          d="M118.7,174c-3.7,25.8-4.3,37.5-4.3,37.5S113.8,201.1,118.7,174Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_55"
          data-name="Vector 55"
          class="cls-4"
          d="M126.7,177.7c-3.8,25.8-4.3,37.5-4.3,37.5S121.7,204.8,126.7,177.7Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_56"
          data-name="Vector 56"
          class="cls-4"
          d="M122.8,176.3c-1.5,27.8-4.3,37.5-4.3,37.5S120.3,198.9,122.8,176.3Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_57"
          data-name="Vector 57"
          class="cls-4"
          d="M143.9,186.1c-1.5,27.8-4.3,37.5-4.3,37.5S141.4,208.7,143.9,186.1Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_58"
          data-name="Vector 58"
          class="cls-4"
          d="M145.7,182.5c5.4,27.3,5,37.4,5,37.4S148.9,205.1,145.7,182.5Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_59"
          data-name="Vector 59"
          class="cls-4"
          d="M135.1,182.5c-1.5,27.8-4.3,37.5-4.3,37.5Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_60"
          data-name="Vector 60"
          class="cls-4"
          d="M149.6,180.8s.8,3.7,1.6,8.8c-13.4,2.7-21-2.6-21.2-6.7-2.7,2.5-3.6-2.3-11.2-6.8-4.8-3.2-5.8-2.8-5.5-6.3s-4.5.3-2.8-8.8c.3-1.4-2.6-.5-2.1-3.3s.7-4.3,1.1-6.5C113,149.5,149.6,180.8,149.6,180.8Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_61"
          data-name="Vector 61"
          class="cls-4"
          d="M111.3,109c2.2-1.3,34.9,36.1,34.9,36.1s1.9,5,1.3,8c-2.1,18.2,10.7,29.1,2.6,33.1a6.8,6.8,0,0,1,.1,1.2c-.1,1.8-18,1.8-19-4.5a8.1,8.1,0,0,1-1-2.7l-1.5-1.2c-.2,1.5-.8,2.4-1.6,2.3-7.4-7.1-9.9-6.4-12.2-9.5a9.6,9.6,0,0,1-.7-3.3c-1.2-.8-2.7-1.9-3.1-2.9a16.7,16.7,0,0,1,.2-4.8C100.7,143.9,116.7,127.5,111.3,109Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_62"
          data-name="Vector 62"
          class="cls-4"
          d="M147.5,153.1a19.4,19.4,0,0,0-.2,2.4c-5.1-14.1-15.4-4.3-23.9-16.9-1-.8-.6-4.5-.6-4.5-4.2-.6-9.1-7.2-10.5-16.9.2-3.4-.1-4.6-1-8.1,2.2-1.3,34.9,36.1,34.9,36.1S148.1,150.1,147.5,153.1Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_63"
          data-name="Vector 63"
          class="cls-4"
          d="M113.8,144.2c-1.9,20.7.3,24.2.3,24.2S114.7,153,113.8,144.2Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_64"
          data-name="Vector 64"
          class="cls-4"
          d="M113.6,121c-2,18.5-1.2,21.6-1.2,21.6S113.6,128.9,113.6,121Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_65"
          data-name="Vector 65"
          class="cls-4"
          d="M136.5,164.3c11.2,14.9,14.3,16.2,14.3,16.2S142.2,169.8,136.5,164.3Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_66"
          data-name="Vector 66"
          class="cls-4"
          d="M117.1,134.8c-.7,24.1,11.5,42.9,11.5,42.9S118.5,160.6,117.1,134.8Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_67"
          data-name="Vector 67"
          class="cls-4"
          d="M125.2,115.4c-8.8,16.7-4.1,35.3-4.1,35.3A67.6,67.6,0,0,1,125.2,115.4Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_68"
          data-name="Vector 68"
          class="cls-4"
          d="M128.5,136c.2,13.5,13.1,23.3,13.1,23.3S130.9,150.4,128.5,136Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_69"
          data-name="Vector 69"
          class="cls-4"
          d="M122.8,134c2.5,30.7,18.2,41.4,18.2,41.4S127.2,164.1,122.8,134Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_70"
          data-name="Vector 70"
          class="cls-4"
          d="M128,117.3c2.5,30.7,18.2,41.4,18.2,41.4S132.4,147.4,128,117.3Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_71"
          data-name="Vector 71"
          class="cls-4"
          d="M138.6,61.3l7.7-2.6-6.5,3.8Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_72"
          data-name="Vector 72"
          class="cls-4"
          d="M146.3,58.7l-6,4.9-.4-1.1Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_73"
          data-name="Vector 73"
          class="cls-3"
          d="M135.6,76.1c-.8,4,.5,5.3.5,5.3L131.5,90l-9.6,1.9-1.2-8.3,7.4-1.6s3.8-1.5,5-4.7A5.5,5.5,0,0,0,135.6,76.1Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_74"
          data-name="Vector 74"
          class="cls-4"
          d="M135.6,76.1a1.5,1.5,0,0,0-.1.7,2.1,2.1,0,0,1-2.1.8,7.8,7.8,0,0,1-8.2,5.8c-.2-1,5.1-3.9,5.1-3.9S131.2,76.1,135.6,76.1Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_75"
          data-name="Vector 75"
          class="cls-4"
          d="M135.7,80.6a2.2,2.2,0,0,0,.4.7L130,88s-4.1,8-7.1,2.2,2.2-7,2.2-7,.5,7.2,3.8,2.8C130.1,84.7,132.9,81.2,135.7,80.6Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_76"
          data-name="Vector 76"
          class="cls-4"
          d="M119.5,78.1a7.4,7.4,0,0,0-5.6,7.8c.2,6.6.2,10.2-.8,13.9s7.4-6,7.4-6L122,78.7Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_77"
          data-name="Vector 77"
          class="cls-4"
          d="M114.7,87.6l.8,4.9-.6-.2Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_78"
          data-name="Vector 78"
          class="cls-4"
          d="M115.8,84.7l.8,6.9H116Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_79"
          data-name="Vector 79"
          class="cls-4"
          d="M118.7,78.3a9.8,9.8,0,0,0,.2,3.2,6.2,6.2,0,0,0-2.5,4.8c.3,5.8-2.7-.4-3.4,13.4-1,3.7,7.4-6,7.4-6L121.9,77Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_80"
          data-name="Vector 80"
          class="cls-4"
          d="M120.2,88.4c2.5,30.7,18.9,53.5,18.9,53.5S124.6,118.5,120.2,88.4Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_81"
          data-name="Vector 81"
          class="cls-4"
          d="M117.7,88c2,0,3.2-.5,6.1,0,6.1,21.9,21.5,23.5,22.2,35.4-3.8,17.9,8,28.8,1.5,29.7-7.7-12.3-9.5-1.8-22.6-14-.4-.6-.8-2.9-1.1-5.8-7.9-3.6-10.3-15-12.6-18.2-.5-.7-.4-3,.1-5.9C109.3,102.2,110.5,94.9,117.7,88Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_82"
          data-name="Vector 82"
          class="cls-4"
          d="M123.8,133.1s-4.5-22.7-4.3-44.2C116.1,104.5,123.8,133.1,123.8,133.1Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_83"
          data-name="Vector 83"
          class="cls-4"
          d="M118.9,127.6s-6.7-15.8.6-40.6C110.9,107.5,118.9,127.6,118.9,127.6Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_84"
          data-name="Vector 84"
          class="cls-4"
          d="M121.3,88.4s4,11.2,8.7,18.3A43.3,43.3,0,0,1,121.3,88.4Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_85"
          data-name="Vector 85"
          class="cls-4"
          d="M120.2,87.8c6.1,29.8,14.2,34.7,14.2,34.7S127.3,115.2,120.2,87.8Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_86"
          data-name="Vector 86"
          class="cls-4"
          d="M111.4,109.4a149.5,149.5,0,0,1,6.7-20.9C111.1,103.7,111.4,109.4,111.4,109.4Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_87"
          data-name="Vector 87"
          class="cls-4"
          d="M125.4,83.4c-1.5,1.4,2.5,7.8-5.1,6.5s.6-9.6.6-9.6S126.6,82,125.4,83.4Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_88"
          data-name="Vector 88"
          class="cls-4"
          d="M125.4,82.8c-1.5,1.4,2.5,7.8-5.1,6.5s.6-9.6.6-9.6S126.6,81.5,125.4,82.8Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_89"
          data-name="Vector 89"
          class="cls-4"
          d="M123.9,81.9a12.4,12.4,0,0,0-.8,5.1,13.7,13.7,0,0,1,.2-5.1Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_90"
          data-name="Vector 90"
          class="cls-4"
          d="M121,81.6a14.3,14.3,0,0,0-3.4,3.9,13.1,13.1,0,0,1,2.9-4.2Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_91"
          data-name="Vector 91"
          class="cls-4"
          d="M121.6,82.8a24.6,24.6,0,0,0-1.4,4.9,18,18,0,0,1,1-5Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_92"
          data-name="Vector 92"
          class="cls-4"
          d="M123.3,79.7a24.6,24.6,0,0,0-1.4,4.9,18,18,0,0,1,1-5Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_93"
          data-name="Vector 93"
          class="cls-4"
          d="M121.9,80.2a21.5,21.5,0,0,0-2.2,4.7,17.5,17.5,0,0,1,1.9-4.8Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_94"
          data-name="Vector 94"
          class="cls-4"
          d="M124.9,58.4l-6.8-5.7,5.1,6.5Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_95"
          data-name="Vector 95"
          class="cls-4"
          d="M123.2,59.1l-1.5-.2-3.6-6.3Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_96"
          data-name="Vector 96"
          class="cls-4"
          d="M132.9,58.3l-.3-4.9-1.9,4.3Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_97"
          data-name="Vector 97"
          class="cls-3"
          d="M119,66.3a10.2,10.2,0,0,0-.2,4.8c-.8,3.2.3,10.4.7,10.9s1.4,1.5,3.5,1.5,8.2-.4,10.2-6.4c.9.3,5.5-2.5,3.9-5-.3-.5,6.5-6.4-3.3-12.3C131.1,58.3,121.5,57,119,66.3Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_98"
          data-name="Vector 98"
          class="cls-4"
          d="M119,66.3c-.1.5-.2.9-.3,1.5s1.4,1.6,2.6,1.2c.3,2.2,4.7,1.9,7.6,4.1s2.8,7.7,3.6,5.8a7.7,7.7,0,0,0,.7-1.6c.9.3,5.5-2.5,3.9-5-.3-.5,6.5-6.4-3.3-12.3C131.1,58.3,121.5,57,119,66.3Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_99"
          data-name="Vector 99"
          class="cls-4"
          d="M122.1,68.3s-1.9.5-2.8,0-1.6-2.9-.8-5.4a5.3,5.3,0,0,1,3-2.7v3.5l2.3.9Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_100"
          data-name="Vector 100"
          class="cls-4"
          d="M122.6,64.8c-3.6,7.3,4.3,4.9,7.4,8.9s2.2,5.8,3.5,7.2c4.7,4.6,4.6-2.9,4.6-2.9s4.3-1.1,4.3-7.3-3.1-8.6-3.1-8.6,4.7,3.3-.7,5.5-7.1.7-7.1.7L124.2,67A3.1,3.1,0,0,1,122.6,64.8Z"
          transform="translate(-0.9 -0.2)"
        />
        <g id="Group_16" data-name="Group 16">
          <path
            id="Vector_101"
            data-name="Vector 101"
            class="cls-4"
            d="M140.4,65.4c-.7,2.5-5,2.9-10.5,1.4-7.2-1.9-8.4-4.4-8.4-5a4,4,0,0,1,.2-2.2c-4.1,1.6-2.1,5.4-2.1,5.4s1.9,4.4,9.5,5.9,10.8-.7,11.7-1c3.1-1.9,1.7-4.8.2-6.1Z"
            transform="translate(-0.9 -0.2)"
          />
          <path
            id="Vector_102"
            data-name="Vector 102"
            class="cls-4"
            d="M139,61.7a11.6,11.6,0,0,1,1.4,3.1c-.7,2.5-5,2.9-10.5,1.4-7.2-1.9-8.4-4.4-8.4-5a10.5,10.5,0,0,1,3.3-2.9,7.6,7.6,0,0,0-3.1.6c-4.1,1.7-2.1,5.5-2.1,5.5s1.9,4.4,9.5,5.8,10.8-.7,11.7-1c3.1-1.9,1.7-4.9.2-6.1Z"
            transform="translate(-0.9 -0.2)"
          />
          <path
            id="Vector_103"
            data-name="Vector 103"
            class="cls-4"
            d="M128,68l1,1.1,2.1-.5.3-1.6-3-.7Z"
            transform="translate(-0.9 -0.2)"
          />
          <path
            id="Vector_104"
            data-name="Vector 104"
            class="cls-4"
            d="M131.6,66.9,129.1,69l-.5-2.9Z"
            transform="translate(-0.9 -0.2)"
          />
          <path
            id="Vector_105"
            data-name="Vector 105"
            class="cls-4"
            d="M123.8,64l-7.9-.5,6.5-.8Z"
            transform="translate(-0.9 -0.2)"
          />
          <path
            id="Vector_106"
            data-name="Vector 106"
            class="cls-4"
            d="M120.7,61.3l-9.6-4.7L121.3,60Z"
            transform="translate(-0.9 -0.2)"
          />
          <path
            id="Vector_107"
            data-name="Vector 107"
            class="cls-4"
            d="M140.9,64.5l9.9.9-9.9.6Z"
            transform="translate(-0.9 -0.2)"
          />
          <path
            id="Vector_108"
            data-name="Vector 108"
            class="cls-4"
            d="M139.2,66.4l4.4,2.7-7-1.9Z"
            transform="translate(-0.9 -0.2)"
          />
          <path
            id="Vector_109"
            data-name="Vector 109"
            class="cls-4"
            d="M143.5,69.1l-6.6-.2-.4-1.7Z"
            transform="translate(-0.9 -0.2)"
          />
          <path
            id="Vector_110"
            data-name="Vector 110"
            class="cls-4"
            d="M123.8,64l-.7,1.3-7.2-1.9Z"
            transform="translate(-0.9 -0.2)"
          />
          <path
            id="Vector_111"
            data-name="Vector 111"
            class="cls-4"
            d="M120.7,61.3l-1,1L111,56.6Z"
            transform="translate(-0.9 -0.2)"
          />
          <path
            id="Vector_112"
            data-name="Vector 112"
            class="cls-4"
            d="M150.7,65.3l-9.7,2-.2-1.4Z"
            transform="translate(-0.9 -0.2)"
          />
        </g>
        <path
          id="Vector_113"
          data-name="Vector 113"
          class="cls-4"
          d="M147.8,78.8c2.7,6.9,6.7,7.3,6.6,12.6-.2.8-.3,4.7-4.9,4.1a4.9,4.9,0,0,1-4.7-4.7S143.4,76.7,147.8,78.8Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_114"
          data-name="Vector 114"
          class="cls-3"
          d="M150.8,47.6c-.2,13,1.5,19.6,0,23.1-3.3,9,1.3,25.1-5.3,30.6-1.6,1-6.5-1.4-7.4-6.5s5.4-20.9,5.3-24.7c-2.5-8.4,3.8-24.8,3.8-24.8A35.7,35.7,0,0,1,150.8,47.6Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_115"
          data-name="Vector 115"
          class="cls-4"
          d="M151,58.4a1.1,1.1,0,0,1-.8,1,6.4,6.4,0,0,1-4.3,0,1.4,1.4,0,0,1-.8-1v-7l.9-2.8,4.7,3.5Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_116"
          data-name="Vector 116"
          class="cls-4"
          d="M149.2,91.9c-.3,4-1.3,7.5-3.7,9.5s-6.5-1.4-7.4-6.5,2.4-12.8,4.2-19.1C139.5,90.9,149.2,91.9,149.2,91.9Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_117"
          data-name="Vector 117"
          class="cls-4"
          d="M142,76.6c-3.9,16.3,9.5,18.8,12.3,14.8-.4,6.3-4.8,7.6-4.8,7.6s1.5,4.5-1.9,3.5c-.5-.5.3,2.4-.4,5s-2.6,1.6-2,3.2,3.1,2.8,2.3,6.7a7,7,0,0,1-1.9,3.5c-2.2-7.7-16.6-13.9-21.4-31.2,5-.4,6.8-7.2,11.6-8.4,1.7.9,1.9.9,2.2,2.3a3.2,3.2,0,0,0,.7.6s.5,1.4,1-.4-.9-1.9-.7-4.4S142.4,75.9,142,76.6Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_118"
          data-name="Vector 118"
          class="cls-4"
          d="M132.1,79.2s-.2,2.1,3.1,3.5,2-.7,2-.7-.7,1.5-2.6-.1a5.5,5.5,0,0,1-2.1-3Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_119"
          data-name="Vector 119"
          class="cls-4"
          d="M146.2,120.1l-.6.7c-2.2-7.7-16.6-13.9-21.4-31.2l1.4-.3C127,105.5,141.8,107.9,146.2,120.1Z"
          transform="translate(-0.9 -0.2)"
        />
        <g id="Group_17" data-name="Group 17">
          <path
            id="Vector_120"
            data-name="Vector 120"
            class="cls-4"
            d="M150.8,56.9a1.1,1.1,0,0,1-.8,1,3.8,3.8,0,0,1-3.6,0,1.4,1.4,0,0,1-.8-1V30.7h5.1V56.9Z"
            transform="translate(-0.9 -0.2)"
          />
        </g>
        <path
          id="Vector_121"
          data-name="Vector 121"
          class="cls-4"
          d="M151.9,39.4c-1.8-.4-3.1-.3-4.3,1.2s-.2,4.7,0,5.8,2.4,1.8,3.2,1.2S153.9,40,151.9,39.4Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_122"
          data-name="Vector 122"
          class="cls-3"
          d="M152.5,39.8c-1.8-.4-3.1-.3-4.3,1.2s-.2,4.7,0,5.8,2.4,1.4,3.2.7S154.6,40.4,152.5,39.8Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_123"
          data-name="Vector 123"
          class="cls-4"
          d="M145.2,41.7c0,1.4.4,2.5,1,2.5s1-1.1,1-2.5-.5-2.5-1-2.5S145.2,40.3,145.2,41.7Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_124"
          data-name="Vector 124"
          class="cls-3"
          d="M144.6,41.7c0,1.4.4,2.5,1,2.5s1-1.1,1-2.5-.4-2.5-1-2.5S144.6,40.3,144.6,41.7Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_125"
          data-name="Vector 125"
          class="cls-4"
          d="M144,142.6c-1.9-8.9-9.5-20.1-9.5-20.1S142.6,132.2,144,142.6Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_126"
          data-name="Vector 126"
          class="cls-4"
          d="M138.1,83.5c-13.3,4-4.2,19.3-4.2,19.3S125.8,88.5,138.1,83.5Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_127"
          data-name="Vector 127"
          class="cls-4"
          d="M151.4,94.9c-11.4,4.4-11.6-11.1-11.6-11.1S140.4,97.7,151.4,94.9Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_128"
          data-name="Vector 128"
          class="cls-4"
          d="M139.3,84.7s-3.2,11.9,8.9,13.6C136.4,95.5,139.3,84.7,139.3,84.7Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_129"
          data-name="Vector 129"
          class="cls-4"
          d="M147.7,102.3s-16.2-2.2-10.6-16.3C130.5,101.6,147.7,102.3,147.7,102.3Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_130"
          data-name="Vector 130"
          class="cls-4"
          d="M143.5,108.4s-8.4-1.9-10.1-14.3C133.7,106.4,143.5,108.4,143.5,108.4Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_131"
          data-name="Vector 131"
          class="cls-4"
          d="M132.9,84.7c-10.4,8.2-2.3,16-2.3,16S123.4,93.8,132.9,84.7Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_132"
          data-name="Vector 132"
          class="cls-4"
          d="M145.6,115.2c-3.7-6.6-6.5-5.5-11.7-10C141.1,109.8,143.3,110,145.6,115.2Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_133"
          data-name="Vector 133"
          class="cls-4"
          d="M130,106.7c6.1,10.8,7.8,7.7,12.4,19.3C140.1,117.1,134.1,113.5,130,106.7Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_134"
          data-name="Vector 134"
          class="cls-4"
          d="M135.7,58.7s-3.6-4.8-10.7-1.8c-3.4,2.1-3.5,4.2-3.5,4.2s-.1,1.4,2.9,3.1c.4.3,9-1.5,9-1.5Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_135"
          data-name="Vector 135"
          class="cls-4"
          d="M139.8,61.1c-6.2-8.4-15.6,2.7-15.7,2.9s9.6,4.5,13.9,2.7S140.4,61.7,139.8,61.1Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_136"
          data-name="Vector 136"
          class="cls-4"
          d="M139.8,61.1c3.8,9.8-13.4,4.1-15.7,2.9,1.2.9,9.6,4.5,13.9,2.7S140.4,61.7,139.8,61.1Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_137"
          data-name="Vector 137"
          class="cls-4"
          d="M128.2,73.3a46.3,46.3,0,0,0-5.6-.4A8.9,8.9,0,0,1,128.2,73.3Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_138"
          data-name="Vector 138"
          class="cls-4"
          d="M118.6,69a7.6,7.6,0,0,1,2.2,2.9A3.5,3.5,0,0,0,118.6,69Z"
          transform="translate(-0.9 -0.2)"
        />
        <g id="Group_18" data-name="Group 18">
          <path
            id="Vector_139"
            data-name="Vector 139"
            class="cls-4"
            d="M142.6,26.7h.1a2.9,2.9,0,0,1,1.5-1.6,8.7,8.7,0,0,1,8,0,3.2,3.2,0,0,1,1.5,1.6h.1v3.9a2.9,2.9,0,0,1-1.6,2.3,8.7,8.7,0,0,1-8,0,2.9,2.9,0,0,1-1.6-2.3V26.7Z"
            transform="translate(-0.9 -0.2)"
          />
          <path
            id="Vector_140"
            data-name="Vector 140"
            class="cls-4"
            d="M144.2,24.4a8.7,8.7,0,0,1,8,0c2.2,1.3,2.2,3.3,0,4.7a8.7,8.7,0,0,1-8,0C142,27.7,142,25.6,144.2,24.4Z"
            transform="translate(-0.9 -0.2)"
          />
        </g>
        <path
          id="Vector_141"
          data-name="Vector 141"
          class="cls-4"
          d="M152.9,27.1a9,9,0,0,0,3.3-9.9c-2.7,2.7-4.3,1.4-4.3,1.4s6.7-3.4,1.6-15.7c-.4,7.3-4.3,9.2-6.5,13.2,3-7.4-1.5-10.3-.8-15.4-9.8,13.1-3.3,18.8-3.3,18.8s-2.2.4-3.2-5.2c-3.2,9.5,3.8,12.8,3.8,12.8s-.3,2.2,4.7,2.2S152.9,27.1,152.9,27.1Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_142"
          data-name="Vector 142"
          class="cls-4"
          d="M153.5,6.5c-.5,9.3-8,10.9-8.9,19.5C144.1,17.9,152.6,15.4,153.5,6.5Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_143"
          data-name="Vector 143"
          class="cls-4"
          d="M155.4,19c-2.2,7.5-8.6,2-10.7,7C146.3,20.7,154,25.5,155.4,19Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_144"
          data-name="Vector 144"
          class="cls-4"
          d="M139.8,17.6c-1.2,6.1,4.8,8.4,4.8,8.4S139.8,24.1,139.8,17.6Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_145"
          data-name="Vector 145"
          class="cls-4"
          d="M147.1,16c-6.7,2.6-2.4,10-2.4,10S141.4,18.6,147.1,16Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_146"
          data-name="Vector 146"
          class="cls-4"
          d="M153.1,24.4c-.3,6.3-8.5,1.6-8.5,1.6S152,30.2,153.1,24.4Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          id="Vector_147"
          data-name="Vector 147"
          class="cls-4"
          d="M145.2,3.7c-5.6,8.2-2.2,14.4-2.2,14.4S140.5,12,145.2,3.7Z"
          transform="translate(-0.9 -0.2)"
        />
      </g>
    </g>
    <path
      id="Shadow"
      class="cls-2"
      d="M32.4,285.8l31.2,18.1-1.1.7L31.1,286.5Zm40,12.2a2.2,2.2,0,0,1-.7.9L40.5,281l1.3-.5Zm-2.5,2.1-1.3.7L37.4,282.9l1.1-.7Zm-3.3,2-1.1.5L34.3,284.7l1.1-.7ZM43.9,315.2c-.2,0-.2.2-.4.2L13,297.8l.5-.9,21.3,12.4.4-.2,61.9,35.7-.2.2-.9.5Zm-12.8-3.8,1.1-.7,62.1,35.9-1.1.7Zm-3.2,1.8,1.1-.5,61.9,35.7-.2.2-.7.5ZM24.8,315l1.1-.5L88,350.1l-1.1.7Zm-3.2,1.8,1.1-.5,62.1,35.9-1.1.5Zm-3,2,1.1-.7L81.8,354l-1.1.5Zm-3.3,1.7,1.1-.7,62.1,35.9-.2.2-.9.5Zm-3,1.8,1.1-.7,62.1,35.9-1.1.7Zm-3.2,1.8,1.1-.5L72,359.3l-.2.2-.7.5Zm-3.3,1.8,1.3-.5L69,361.1v.2l-1.1.5Zm-2.1,2.5.5-.9L65.7,363l-.2.2a2.5,2.5,0,0,1-1.1.4Zm-.6,2,58.3,33.7H59.1L3.3,332A4.1,4.1,0,0,0,3.1,330.4ZM59.8,306l-.4.2L28.2,288.1l1.1-.7,22.8,13.3h.7l57.2,33c0,.4.2.9,0,1.3Zm-3.2,2-.4.2L25,290.1l1.1-.7,21.5,12.4.4-.2,61.3,35.7a5.5,5.5,0,0,1-.7.9Zm49.1,31.9L53.5,309.8l-.4.2L21.7,291.9l1.3-.5,21.3,12.4.4-.2,62.1,35.7ZM50.3,311.6l-.4.2L18.7,293.9l1.1-.7,21.3,12.4.4-.2,62.1,35.9-1.1.5Zm-3,1.8-.4.4L15.7,295.7l1.1-.7,21.3,12.4.4-.2,62.1,35.9-1.1.5Z"
      transform="translate(-0.9 -0.2)"
    />
    <path
      id="Shadow2"
      class="cls-1"
      d="M116.5,335.6,85.1,317.5l1.3-.7,31.2,18.1Zm9.9-6.6L95.7,311.4l-1.3.5,31.2,17.9C126,329.7,126.2,329.3,126.4,329Zm-2.5,2.1L92.5,313.2l-1.1.7,31.2,17.9Zm-3.3,2L89.4,315l-1.1.7,31.2,17.9Zm-31.7,7.2L67.6,327.9a1.9,1.9,0,0,0-.5.9l30.5,17.6c.2,0,.2-.2.4-.2l52.2,30.3.9-.5.2-.2L89.4,340.1Zm-3.8,2.1,62.1,35.9,1.1-.7L86.2,341.7Zm-3.2,1.8L144,380.1l.7-.5.2-.2L83,343.7ZM78.8,346l62.1,35.9,1.1-.7L79.9,345.5Zm-3.2,1.8,62.1,35.9,1.1-.5L76.7,347.3Zm-3,2,62.1,35.7,1.1-.5L73.6,349Zm-3.3,1.7,62.1,35.9.9-.5.2-.2L70.4,350.8Zm-3,1.8,62.1,35.9,1.1-.7L67.4,352.6Zm-3.2,1.8L125.2,391l.7-.5.2-.2L64.2,354.6Zm-3.3,1.8,62.1,35.9,1.1-.5v-.2L61.1,356.4Zm-2.1,2.5,60.8,35.2a2.5,2.5,0,0,0,1.1-.4l.2-.2L58.3,358.5C58,358.7,57.9,359.1,57.7,359.4Zm-.4,3.6,55.8,32.1h2.3L57.1,361.4A4.1,4.1,0,0,1,57.3,363ZM164,364.6l-57.2-33h-.7L83.3,318.3l-1.1.7,31.2,18.1.4-.2L164,365.8C164.2,365.5,164,365,164,364.6Zm-62.4-31.9L80.1,320.3,79,321l31.2,18.1.4-.2,52,30.1a2.8,2.8,0,0,0,.7-.9L102,332.5Zm-3.2,2L77.1,322.3l-1.3.5,31.4,18.1.4-.2,52.2,30.1,1.1-.7L98.8,334.4Zm-3.2,1.8L73.9,324.1l-1.1.7L104,342.7l.4-.2,52.2,30.1,1.1-.5L95.6,336.2Zm-3.1,1.8L70.8,325.9l-1.1.7,31.2,18.1.4-.4,52.2,30.1,1.1-.5L92.5,338Z"
      transform="translate(-0.9 -0.2)"
    />
    <g id="Block1">
      <path
        class="cls-1"
        d="M53.8,382h0a3.4,3.4,0,0,0-.9-.8L47.2,378a4.1,4.1,0,0,0-4,0l-5.6,3.3a2,2,0,0,0-.8.8h-.3v2.9a1.7,1.7,0,0,0,1,1.6l5.7,3.2a4.6,4.6,0,0,0,2,.5,2.7,2.7,0,0,0,2.1-.7l5.6-3.3a2,2,0,0,0,1-1.4v-3Zm-7.2-3.1,5.7,3.2a.7.7,0,0,1,.4.5c0,.1-.1.3-.4.5l-5.6,3.3a3.7,3.7,0,0,1-2.9,0l-5.7-3.2a.7.7,0,0,1-.4-.5c0-.1.1-.3.4-.5l5.6-3.3A3.7,3.7,0,0,1,46.6,378.9Zm-1.8,10.9v-2.2h.8v2.2Z"
        transform="translate(-0.9 -0.2)"
      />
      <path
        class="cls-5"
        d="M38.1,382.2c-.3.2-.4.4-.4.5a.7.7,0,0,0,.4.5l5.7,3.2a3.7,3.7,0,0,0,2.9,0l5.6-3.3c.3-.2.4-.4.4-.5a.7.7,0,0,0-.4-.5l-5.7-3.2a3.7,3.7,0,0,0-2.9,0Z"
        transform="translate(-0.9 -0.2)"
      />
      <rect class="cls-6" x="43.9" y="387.4" width="0.8" height="2.2" />
    </g>
    <g id="Circle1">
      <path
        class="cls-5"
        d="M121,391.8a2.6,2.6,0,0,0,1.6-2.2,2.8,2.8,0,0,0-1.6-2.2,8.3,8.3,0,0,0-4.3-1,8.9,8.9,0,0,0-4.4,1,2.6,2.6,0,0,0-1.6,2.2,2.8,2.8,0,0,0,1.6,2.2A9.5,9.5,0,0,0,121,391.8Z"
        transform="translate(-0.9 -0.2)"
      />
      <path
        class="cls-1"
        d="M121.6,386.4a10.8,10.8,0,0,0-9.9,0,3.9,3.9,0,0,0-2.1,2.7h-.1v3.5a3.9,3.9,0,0,0,2.2,3.2,10.3,10.3,0,0,0,5,1.2,8.8,8.8,0,0,0,4.9-1.3,3.7,3.7,0,0,0,2.2-3.1v-3A3.9,3.9,0,0,0,121.6,386.4Zm-10.9,3.2a2.6,2.6,0,0,1,1.6-2.2,8.9,8.9,0,0,1,4.4-1,8.3,8.3,0,0,1,4.3,1,2.8,2.8,0,0,1,1.6,2.2,2.6,2.6,0,0,1-1.6,2.2,9.5,9.5,0,0,1-8.7,0A2.8,2.8,0,0,1,110.7,389.6Zm8.1,3.5h.7v2.8h-.7Zm-7.7-1.1h.7v2.8h-.7Z"
        transform="translate(-0.9 -0.2)"
      />
      <rect class="cls-6" x="117.9" y="392.9" width="0.7" height="2.8" />
      <rect class="cls-6" x="110.2" y="391.8" width="0.7" height="2.8" />
    </g>
    <g id="Screen">
      <path
        class="cls-5"
        d="M43.7,342.2c-.7.4-1.1.9-1.1,1.3s.4.7.7.9l40.4,23.3c1.3.8,3.7.6,5.3-.2l14.2-8.2L58.6,333.6Z"
        transform="translate(-0.9 -0.2)"
      />
      <polygon class="cls-5" points="131.4 273.2 137.1 269.6 21.9 203.1 16.2 206.7 131.4 273.2" />
      <path
        class="cls-5"
        d="M139.6,280.6a11,11,0,0,1,.9,4.2v21l6.4-4V280.9a10.4,10.4,0,0,0-1-4.2Z"
        transform="translate(-0.9 -0.2)"
      />
      <polygon class="cls-5" points="139.6 366.8 146 362.7 146 303.2 139.6 307.2 139.6 366.8" />
      <path
        class="cls-5"
        d="M135.4,275.2a9.7,9.7,0,0,1,3.6,4.1l6.2-3.9a7.8,7.8,0,0,0-2.8-2.9l-3.1-1.8-5.7,3.6Z"
        transform="translate(-0.9 -0.2)"
      />
      <path
        class="cls-5"
        d="M15.7,206.1l5.8-3.6-1.2-.7a4,4,0,0,0-2.3-.6c-.2,0-3-.5-6.5,2.9l1.6.5Z"
        transform="translate(-0.9 -0.2)"
      />
      <path
        class="cls-5"
        d="M140.5,373.3a5.8,5.8,0,0,1-.6,2.8,20.7,20.7,0,0,0,5.8-3.5h.1a3.7,3.7,0,0,0,1.1-3.1v-4.8l-6.4,4v4.7Z"
        transform="translate(-0.9 -0.2)"
      />
      <path
        class="cls-1"
        d="M143.3,271.1,21,200.5a6.7,6.7,0,0,0-2.9-.8c-.2,0-4.7-.8-9.6,5.2l-.2.3h0a5.4,5.4,0,0,0-1,3.5v89.5a11.1,11.1,0,0,0,.5,2.5,12.3,12.3,0,0,0,4.5,6.2L57,332.8,42.8,341a3.3,3.3,0,0,0-1.8,2.3c0,.1-.1.2-.1.3a20,20,0,0,0,.2,6.1c.1.1.5,1.4,1.4,1.9L83,374.8a5.8,5.8,0,0,0,3,.7,8.1,8.1,0,0,0,3.7-.9l20-11.6,25,14.5a3.8,3.8,0,0,0,2.2.7l1-.2c1.3-.1,4.4-.7,8.7-4.5h.1a5,5,0,0,0,1.7-4.2V280.7C148.4,277,146.1,272.7,143.3,271.1Zm-.8,1.3a9.7,9.7,0,0,1,2.8,2.9l-6.2,3.9a9.7,9.7,0,0,0-3.6-4.1l-1.8-1,5.7-3.6Zm-4.5-2.6-5.7,3.6L17.1,206.9l5.8-3.6ZM18,201.2a4,4,0,0,1,2.3.6l1.2.7-5.8,3.6-2.6-1.5a3.7,3.7,0,0,0-1.6-.5C15,200.7,17.8,201.2,18,201.2ZM42.5,312.6l.4-.7,20.2,11.7-.4.7Zm43.7,62.1h-.8v-5.8h.8Zm2.8-7.2c-1.6.8-4,1-5.3.2L43.3,344.4c-.3-.2-.7-.5-.7-.9s.4-.9,1.1-1.3l14.9-8.6,44.6,25.7ZM69.5,330.2v-3.7a2.4,2.4,0,0,1,1.1-2.2,2.1,2.1,0,0,1,2,.1l3.7,2.1a4.9,4.9,0,0,1,2.1,4v3.7a2.6,2.6,0,0,1-1,2.2,2,2,0,0,1-1,.2,2,2,0,0,1-1.1-.3l-3.7-2.1A4.9,4.9,0,0,1,69.5,330.2Zm15.5,7,.4-.7,20.2,11.6-.4.7Zm23.5,25.4-4.5-2.7.4-.7,4.5,2.7Zm30.6-12.7h0a3.3,3.3,0,0,1-1.2,2.7,3.2,3.2,0,0,1-2.9-.4L13.4,282.1a10.5,10.5,0,0,1-4.7-8.2V208.7a3.6,3.6,0,0,1,1.3-3.2l.9-.2a3.8,3.8,0,0,1,1.5.5l122.3,70.6c2.4,1.4,4.4,5.2,4.4,8.4v65.1Zm7.8,19.5a3.7,3.7,0,0,1-1.1,3.1h-.1a19.4,19.4,0,0,1-5.8,3.5,6.1,6.1,0,0,0,.6-2.8v-4.7l6.4-4v4.8Zm0-6.5-6.4,4V307.3l6.4-4Zm0-61.2-6.4,4v-21a10.2,10.2,0,0,0-.9-4.2l6.3-4a10.7,10.7,0,0,1,1,4.2v21Z"
        transform="translate(-0.9 -0.2)"
      />
      <path
        class="cls-6"
        d="M134.7,276.4,12.4,205.8a3.8,3.8,0,0,0-1.5-.5l-.9.2a3.6,3.6,0,0,0-1.3,3.2v65.2a10.5,10.5,0,0,0,4.7,8.2L135,352.2a3.2,3.2,0,0,0,2.9.4,3,3,0,0,0,1.1-2.7h.1V284.8C139.1,281.6,137.1,277.8,134.7,276.4Z"
        transform="translate(-0.9 -0.2)"
      />
      <path
        class="cls-1"
        d="M72.5,332.6l3.7,2.1h.2v-4.2a2.8,2.8,0,0,0-1.2-2.3l-3.7-2.1h-.2v4.2A2.8,2.8,0,0,0,72.5,332.6Z"
        transform="translate(-0.9 -0.2)"
      />
      <rect
        class="cls-6"
        x="52.4"
        y="306.5"
        width="0.8"
        height="23.3"
        transform="translate(-250 204.6) rotate(-60)"
      />
      <rect
        class="cls-6"
        x="94.9"
        y="331.1"
        width="0.8"
        height="23.3"
        transform="translate(-250.1 253.7) rotate(-60)"
      />
      <rect
        class="cls-6"
        x="106"
        y="358.2"
        width="0.8"
        height="5.3"
        transform="translate(-258.9 266.8) rotate(-59.1)"
      />
      <rect class="cls-6" x="84.5" y="368.7" width="0.8" height="5.8" />
      <path
        class="cls-6"
        d="M75.3,336.3a2,2,0,0,0,1.1.3,2,2,0,0,0,1-.2,2.6,2.6,0,0,0,1-2.2v-3.7a4.9,4.9,0,0,0-2.1-4l-3.7-2.1a2.1,2.1,0,0,0-2-.1,2.4,2.4,0,0,0-1.1,2.2v3.7a4.9,4.9,0,0,0,2.1,4Zm-4-9.7v-.5h.2l3.7,2.1a2.8,2.8,0,0,1,1.2,2.3v4.2h-.2l-3.7-2.1a2.8,2.8,0,0,1-1.2-2.3Z"
        transform="translate(-0.9 -0.2)"
      />
    </g>
    <g id="Bubble">
      <g id="Bubble-2" data-name="Bubble">
        <path
          class="cls-1"
          d="M44.7,194.1l-33-19a2.9,2.9,0,0,0-2.7-.3l-6.4,3.9-.2.2H2.2a2.6,2.6,0,0,0-1.3,2.6v25a7.9,7.9,0,0,0,3.6,6.2l5.1,2.9a18.5,18.5,0,0,0,7.9,11.9.9.9,0,0,0,1,0v-.2h.1l5.5-3.4,13.5,7.8a4.1,4.1,0,0,0,1.8.5,2.2,2.2,0,0,0,1-.2h.4l6.4-3.9a3,3,0,0,0,1.1-2.6V200.5A8.2,8.2,0,0,0,44.7,194.1Zm-6.4,36.6L17,218.4h-.7a1,1,0,0,0-.4.5c-.5,2.2.3,4.8,1.2,6.7a17.7,17.7,0,0,1-6.2-10.2,1,1,0,0,0-.5-.8l-5.1-2.9a6.7,6.7,0,0,1-3-5.2v-25a1.7,1.7,0,0,1,.7-1.6c.4-.3,1-.2,1.7.2l33,19.1a6.7,6.7,0,0,1,3,5.2v24.9a1.7,1.7,0,0,1-.7,1.6C39.6,231.2,39,231.1,38.3,230.7Zm2.2-29.6-.4-.6,5.7-3.5.4.6Zm-27-23.9-5.7,3.5-.4-.7,5.7-3.5Zm28.6,49.5-.4-.6,5.7-3.5.4.6Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          class="cls-6"
          d="M40,230.9a1.7,1.7,0,0,0,.7-1.6V204.4a6.7,6.7,0,0,0-3-5.2l-33-19.1c-.7-.4-1.3-.5-1.7-.2a1.7,1.7,0,0,0-.7,1.6v25a6.7,6.7,0,0,0,3,5.2l5.1,2.9a1,1,0,0,1,.5.8,17.7,17.7,0,0,0,6.2,10.2c-.9-1.9-1.7-4.5-1.2-6.7a1,1,0,0,1,.4-.5H17l21.3,12.3C39,231.1,39.6,231.2,40,230.9ZM26.6,207.6a2.1,2.1,0,0,1,.9-1.9,1.5,1.5,0,0,1,1.7.1l2.5,1.5a4.6,4.6,0,0,1,2,3.7v2.4a2.1,2.1,0,0,1-.9,1.9h-.7l-1-.3-2.5-1.5a4.6,4.6,0,0,1-2-3.7Zm-9.1-5.3a2.1,2.1,0,0,1,.9-1.9,1.5,1.5,0,0,1,1.7.1l2.5,1.5a4.6,4.6,0,0,1,2,3.7V208a2.1,2.1,0,0,1-.9,1.9.8.8,0,0,1-.7.2l-1-.3-2.5-1.5a4.6,4.6,0,0,1-2-3.7Zm-9.1-3V197a2.1,2.1,0,0,1,.9-1.9,1.5,1.5,0,0,1,1.7.1l2.5,1.5a4.6,4.6,0,0,1,2,3.7v2.3a2.1,2.1,0,0,1-.9,1.9l-.7.2-1-.3L10.4,203A4.6,4.6,0,0,1,8.4,199.3Z"
          transform="translate(-0.9 -0.2)"
        />
        <rect
          class="cls-6"
          x="39.9"
          y="198.7"
          width="6.7"
          height="0.7"
          transform="translate(-97.9 51.1) rotate(-31.3)"
        />
        <rect
          class="cls-6"
          x="41.4"
          y="224.3"
          width="6.7"
          height="0.7"
          transform="translate(-110.9 55.6) rotate(-31.2)"
        />
        <rect
          class="cls-6"
          x="7.1"
          y="178.3"
          width="6.7"
          height="0.7"
          transform="translate(-92.1 31.2) rotate(-31.3)"
        />
        <path
          class="cls-5"
          d="M11.1,202l2.5,1.5c.1.1.4.2.5.1a1.1,1.1,0,0,0,.3-.9v-2.3a3.3,3.3,0,0,0-1.4-2.7l-2.5-1.5H10a1.1,1.1,0,0,0-.3.9v2.3A3.3,3.3,0,0,0,11.1,202Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          class="cls-1"
          d="M10.4,203l2.5,1.5,1,.3.7-.2a2.1,2.1,0,0,0,.9-1.9v-2.3a4.6,4.6,0,0,0-2-3.7L11,195.2a1.5,1.5,0,0,0-1.7-.1,2.1,2.1,0,0,0-.9,1.9v2.3A4.6,4.6,0,0,0,10.4,203Zm-.7-6a1.1,1.1,0,0,1,.3-.9h.5l2.5,1.5a3.3,3.3,0,0,1,1.4,2.7v2.3a1.1,1.1,0,0,1-.3.9c-.1.1-.4,0-.5-.1L11.1,202a3.3,3.3,0,0,1-1.4-2.7Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          class="cls-5"
          d="M20.1,207.3l2.5,1.5c.1.1.4.2.5.1a1.1,1.1,0,0,0,.3-.9v-2.3A3.3,3.3,0,0,0,22,203l-2.5-1.5c-.1-.1-.4-.2-.5-.1a1.1,1.1,0,0,0-.3.9v2.3A3.3,3.3,0,0,0,20.1,207.3Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          class="cls-1"
          d="M19.5,208.3l2.5,1.5,1,.3a.8.8,0,0,0,.7-.2,2.1,2.1,0,0,0,.9-1.9v-2.3a4.6,4.6,0,0,0-2-3.7l-2.5-1.5a1.5,1.5,0,0,0-1.7-.1,2.1,2.1,0,0,0-.9,1.9v2.3A4.6,4.6,0,0,0,19.5,208.3Zm-.8-6a1.1,1.1,0,0,1,.3-.9c.1-.1.4,0,.5.1L22,203a3.3,3.3,0,0,1,1.4,2.7V208a1.1,1.1,0,0,1-.3.9c-.1.1-.4,0-.5-.1l-2.5-1.5a3.3,3.3,0,0,1-1.4-2.7Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          class="cls-5"
          d="M29.2,212.6l2.5,1.5c.1.1.4.2.5.1a1.1,1.1,0,0,0,.3-.9V211a3.3,3.3,0,0,0-1.4-2.7l-2.5-1.5c-.1-.1-.4-.2-.5-.1a1.1,1.1,0,0,0-.3.9v2.3A3.3,3.3,0,0,0,29.2,212.6Z"
          transform="translate(-0.9 -0.2)"
        />
        <path
          class="cls-1"
          d="M28.6,213.6l2.5,1.5,1,.3h.7a2.1,2.1,0,0,0,.9-1.9V211a4.6,4.6,0,0,0-2-3.7l-2.5-1.5a1.5,1.5,0,0,0-1.7-.1,2.1,2.1,0,0,0-.9,1.9v2.3A4.6,4.6,0,0,0,28.6,213.6Zm-.8-6a1.1,1.1,0,0,1,.3-.9c.1-.1.4,0,.5.1l2.5,1.5a3.3,3.3,0,0,1,1.4,2.7v2.3a1.1,1.1,0,0,1-.3.9c-.1.1-.4,0-.5-.1l-2.5-1.5a3.3,3.3,0,0,1-1.4-2.7Z"
          transform="translate(-0.9 -0.2)"
        />
      </g>
      <g id="Lines">
        <g id="XMLID_45" data-name="XMLID 45">
          <g id="XMLID_46" data-name="XMLID 46">
            <g id="XMLID_47" data-name="XMLID 47">
              <path
                id="XMLID_48"
                data-name="XMLID 48"
                class="cls-1"
                d="M53.7,189.4l-4.3,3.7.9,1.1,4.3-3.7Z"
                transform="translate(-0.9 -0.2)"
              />
            </g>
          </g>
        </g>
        <g id="XMLID_41" data-name="XMLID 41">
          <g id="XMLID_42" data-name="XMLID 42">
            <g id="XMLID_43" data-name="XMLID 43">
              <path
                id="XMLID_44"
                data-name="XMLID 44"
                class="cls-1"
                d="M47.1,185l-2.2,5.3,1.3.5,2.2-5.3Z"
                transform="translate(-0.9 -0.2)"
              />
            </g>
          </g>
        </g>
        <g id="XMLID_37" data-name="XMLID 37">
          <g id="XMLID_38" data-name="XMLID 38">
            <g id="XMLID_39" data-name="XMLID 39">
              <path
                id="XMLID_40"
                data-name="XMLID 40"
                class="cls-1"
                d="M57.8,195.7l-5.5,1.4.4,1.4,5.5-1.4Z"
                transform="translate(-0.9 -0.2)"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
    <g id="BETA">
      <path
        id="shadow-2"
        data-name="shadow"
        class="cls-1"
        d="M127,326.7l-9.9-40.9c0-.1-.1-.2-.1-.3l-.2-.2-3.8-2.2-3.8-2.2H109l-14.1,8.2h-.2l-1.6,4.6v-5.9l8-4.6a.1.1,0,0,0,.1-.1h0v-6.5c0-.1,0-.1-.1-.2l-.2-.3L77.8,262.9h-.2l-1.5.9v-1.7c0-.1,0-.1-.1-.2l-.3-.3-20-11.5h-.2L50,253.2c-.1-.2-.1-.4-.2-.6s-.1-.3-.1-.4l-.3-.8v-.3l-.5-1.1v-.2l-.5-.9-.2-.3-.6-.9-1.2-1.5-.4-.4c-.1-.1-.2-.3-.4-.4l-.6-.6-.4-.4-.7-.6-.4-.3-.8-.7-.3-.2-.4-.3-.8-.6a1,1,0,0,1-.5-.4l-.8-.5-1.3-.8-10-5.8h-.2l-14.3,8.2h0c-.1,0-.1.1-.1.2v35.1a.4.4,0,0,0,.1.3c.1.1.2.2.2.3l11.7,6.8c3.8,2.2,6.7,3,8.8,2.4a6.1,6.1,0,0,0,1.4-.7l-.5.4,5.8-3.4v9.8a.4.4,0,0,0,.1.3l.2.3,20,11.5c.1.1.2.1.2,0l9.5-5.5v10.7a.4.4,0,0,0,.1.3c.1.1.2.2.2.3l7.1,4.1h.3l8.4-4.9-2.7,7.8a.8.8,0,0,0,.1.4c.1.1.2.3.3.3l7.5,4.3c.2.1.3.1.3-.1h-.1l5.8-3.4,4.6,2.6,1.7,7.5a.9.9,0,0,0,.3.5l7.5,4.3a.2.2,0,0,0,.3,0l14.1-8.3Z"
        transform="translate(-0.9 -0.2)"
      />
      <path
        id="b-beta"
        class="cls-5"
        d="M37,280.8a13,13,0,0,0-5-10.2.5.5,0,0,1-.3-.5c0-.2.1-.3.2-.3h-.1l3.6-2.1a6.8,6.8,0,0,0,.4-2.6,14.1,14.1,0,0,0-3-8.6,28.3,28.3,0,0,0-8.7-7.4l-9.6-5.6v34.3l11.3,6.5c3.7,2.1,6.5,2.9,8.4,2.3S37,284.1,37,280.8ZM20.9,253c0-.1,0-.2.1-.2h.2l2.9,1.7a12,12,0,0,1,3.9,3.4,6.7,6.7,0,0,1,1,2.1,8.5,8.5,0,0,1,.3,2.3c0,1.4-.5,2.4-1.4,2.6s-2.3-.2-4-1.2l-2.8-1.6c-.1-.1-.2-.1-.2-.3a.4.4,0,0,1-.1-.3Zm.3,23.2c-.1-.1-.2-.2-.2-.3a.4.4,0,0,1-.1-.3v-8.8c0-.1,0-.2.1-.2h.2l4.6,2.6H26a9.5,9.5,0,0,1,3.5,3.4,8.1,8.1,0,0,1,1.1,4.3c0,1.5-.4,2.5-1.3,2.7a2,2,0,0,1-1.1,0h-.4l-1-.4-1.1-.6Z"
        transform="translate(-0.9 -0.2)"
      />
      <path
        id="e-beta"
        class="cls-5"
        d="M48.6,292h-.3v-9c0-.1,0-.2.1-.2h.2l10.4,6v-5.5l-10.4-6-.2-.3c0-.1-.1-.1-.1-.2v-7.7c0-.1,0-.2.1-.2h.2l12.6,7.3v-5.5l-19.3-11v34.3l19.3,11.1v-5.5Z"
        transform="translate(-0.9 -0.2)"
      />
      <path
        id="t-beta"
        class="cls-5"
        d="M78.3,286.2c0-.1,0-.2.1-.2h.2l2.8,1.6,4.9,2.8v-5.5L64,272.1v5.5l2.8,1.6,4.8,2.8h.1a.3.3,0,0,1,.1.2c.1.1.1.2.1.4v28.4l6.4,3.7Z"
        transform="translate(-0.9 -0.2)"
      />
      <path
        id="a-beta"
        class="cls-5"
        d="M102.4,294.2l-3.4-2h-.2l-3.4-2-9.8,28.7,6.7,3.9,1.7-5.6a.2.2,0,0,1,.3-.1l9.1,5.2a.5.5,0,0,1,.3.5l1.7,7.5,6.7,3.9Zm-6.5,18.3-.3-.3a.3.3,0,0,1,0-.4l2.9-9.3a.2.2,0,0,1,.3-.1h.1a.5.5,0,0,1,.3.5l2.8,12.5c0,.1,0,.3-.1.3h-.3Z"
        transform="translate(-0.9 -0.2)"
      />
    </g>
  </svg>
</template>

<script>
import coords from "@/components/coords.js";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import { mapState } from "vuex";

gsap.registerPlugin(ScrollTrigger);

export default {
  computed: {
    ...mapState(["toggleConfig", "startConfig", "isAnimationDisabled", "viewportSize"]),
  },
  mixins: [coords],
  props: {
    x: {
      type: [Number, String],
      default: 1200,
    },
    y: {
      type: [Number, String],
      default: 50,
    },
    xSmall: {
      type: [Number, String],
      default: 1200,
    },
    ySmall: {
      type: [Number, String],
      default: 50,
    },
  },
  methods: {
    devAnim() {
      gsap
        .timeline({
          scrollTrigger: {
            trigger: "#milestone-statue-dev",
            toggleActions: this.toggleConfig,
            start: this.startConfig,
          },
          defaults: {
            duration: 1,
            ease: "sine",
          },
        })
        .add("statue")
        .from(
          "#Statue path",
          {
            stagger: 0.01,
            scale: 0.4,
            opacity: 0,
            transformOrigin: "50% 100%",
          },
          "statue"
        )
        .from(
          "#BETA #shadow-2",
          {
            scaleX: 0,
            duration: 0.3,
            transformOrigin: "50% 50%",
          },
          "statue"
        );
    },
  },
  mounted() {
    this.devAnim();
  },
};
</script>

<style lang="scss" scoped>
.cls-1,
.cls-2 {
  fill: #0e1e25;
}

.cls-2,
.cls-3,
.cls-4 {
  stroke: #0e1e25;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.cls-3,
.cls-5 {
  fill: #fff;
}

.cls-4,
.cls-6 {
  fill: #ffad43;
}
</style>